import { createGlobalStyle  } from 'styled-components';

export const BodyStyle = createGlobalStyle`
	html {
		font-size: 100%;

		/**
     *@16px = 100% = 1em
     */

		/* 1rem = 16px */
		${({ theme: { media } }) => media.desktop`
        font-size: 100%;
      `}

		/* 1rem = 16px */
		${({ theme: { media } }) => media.notebook`
        font-size: 100%;
      `}

		/* 1rem = 13px */
		${({ theme: { media } }) => media.pad`
        font-size:81.25%;
      `}

		/* 1rem = 12px */
		${({ theme: { media } }) => media.phone`
        font-size: 75%;
      `}
	}
	h1 {
		font-size: 2rem;
	}
	h2 {
		font-size: 1.5rem;
	}
	h3 {
		font-size: 1.25rem;
	}
	h4 {
		font-size: 1.125rem;
	}
	h5 {
		font-size: 1rem;
	}
	h6 {
		font-size: 0.875rem;
	}
`;

export const ButtonStyle = createGlobalStyle`
	button {
		border: 0;
		background-color: transparent;
	}
`;
